// Two forest-tinted elevation steps shared with the website (--shadow-sm/md).
// Elevated cards use `sm`; menus, modals and popovers use `md`.
export const shadows = {
  sm: {
    shadowColor: "#002c15",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 3,
    elevation: 1,
  },
  md: {
    shadowColor: "#002c15",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.12,
    shadowRadius: 16,
    elevation: 4,
  },
} as const;
